import { IConversation, IMessage } from 'app/services/messages';
import { IUser } from 'app/services/user';
import { CancelIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import React from 'react';
import hotToaster, { toast, Toast as ToastType } from 'react-hot-toast';

export interface BaseNotificationProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  toast: ToastType;
  children?: React.ReactNode;
  className?: string;
  header?: React.ReactNode;
  subHeader?: React.ReactNode;
  content?: React.ReactNode;
  icon?: React.ReactNode;
}

export function baseToast(toastUi: any) {
  toast.custom(toastUi, { duration: 2000 });
}
export default function BaseNotification({
  toast: _toast,
  className = 'bg-gray-400',
  children,
  icon,
  header,
  subHeader,
  content,
  ...rest
}: BaseNotificationProps) {
  return (
    <div
      {...rest}
      className={`${
        _toast.visible ? 'animate-enter' : 'animate-leave'
      } min-h-12  max-w-md shadow-lg rounded-xl overflow-hidden cursor-pointer flex border ${className} items-center `}
      onClick={() => toast.dismiss(_toast.id)}
    >
      <div className="flex flex-col p-2  text-sm">
        {header && (
          <div className="flex items-center">
            <div className="mr-2 max-h-10 my-2 rounded-full self-start flex justify-center items-center">
              {icon}
            </div>
            <div className="text-black flex flex-col">
              <div>{header}</div>
              <div className="text-gray-700">{subHeader}</div>
            </div>
          </div>
        )}
        {content && <div className="text-gray-700">{content}</div>}
      </div>

      <div
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          toast.dismiss(_toast.id);
        }}
        className="px-4 cursor-pointer border-l hover:bg-gray-100/10 text-gray-700 overflow-hidden self-stretch flex items-center border-gray-100"
      >
        <CancelIcon className="" />
      </div>
    </div>
  );
}
